import { useSelector } from 'react-redux';
import useQuery from '../../helpers/hooks/useQuery';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
var LastArticles = function LastArticles(_ref) {
  var _ref$app = _ref.app,
    app = _ref$app === void 0 ? null : _ref$app;
  var navigate = useNavigate();
  var _useQuery = useQuery({
      api: useSelector(function (s) {
        return s.config.endpoints.dashboard.lastArticles;
      }),
      params: app ? {
        app: app
      } : null
    }),
    response = _useQuery.response;
  var dict = {
    default: 'Default',
    contact: 'Contact Info',
    faq: 'FAQ',
    news: 'News',
    project: 'Posillico Inc Project',
    product: 'Materials Product',
    video: 'Video',
    career: 'Career',
    team: 'Team'
  };
  var columns = {
    id: {
      title: '_id',
      visible: false
    },
    title: 'Title',
    dateAdded: 'Date',
    type: 'Type',
    app: 'Site'
  };
  var data = [];
  if (response !== null && response !== void 0 && response.articles) {
    response.articles.forEach(function (x) {
      data.push({
        title: x.title,
        _id: x._id,
        type: dict[x.type],
        dateAdded: moment(x.dateAdded).format('MM/DD/YYYY'),
        app: x.clientApp[0] || '-'
      });
    });
  }
  if (['construx', 'ppark'].includes(app)) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Latest ".concat(app ? "".concat(app, " ") : '', "Articles")
  }), /*#__PURE__*/React.createElement(Table, {
    columns: columns,
    data: data,
    tr: {
      onClick: function onClick(row) {
        return navigate("/article/".concat(row._id));
      }
    }
  }))));
};
export default LastArticles;